'use strict';

//TODO: should be removed when ESM will fixed their dialogs
const iconNameMapping = {
	'mxComponents:close': 'close',
	'mxComponents:attachment': 'attachment',
	'mxComponents:chevron-down': 'expand more',
	'mxComponents:send': 'send',
	'mxComponents:file': 'insert_drive_file',
	'mxComponents:file-pdf-box': 'file_pdf',
	'mxComponents:download': 'download',
	'mxComponents:file-image': 'image',
	'mxComponents:create-service-set': 'create_service_set',
	'mxComponents:create-service-group': 'create_service_group',
	'mxComponents:create-service-bundle': 'create_service_bundle',
	'mxComponents:create-service': 'create_service',
	'mxComponents:create-announce': 'create_announce',
	'mxComponents:my-incidents': 'incident',
	'mxComponents:report-incident': 'report_incident',
	'mxComponents:my-accept': 'check_box',
	'mxComponents:my-orders': 'order',
	'mxComponents:order-new-service': 'order_new_service',
	'mxComponents:manage-actions': 'format_list_bulleted',
	'mxComponents:new-action': 'new_action',
	'mxComponents:new-application': 'new_application',
	'mxComponents:new-incident': 'new_incident',
	'mxComponents:search-kb': 'search_kb',
	'mxComponents:my-open-incidents': 'incidents',
	'mxComponents:service-set': 'service_set',
	'mxComponents:service-bundle': 'service_bundle',
	'mxComponents:service-group': 'service_group',
	'mxComponents:service': 'service',
	'mxComponents:filter': 'filter_small',
	'mxComponents:search-drop-down': 'search_drop_down',
	'mxComponents:extension-gallery': 'extension_gallery',
	'mxShell:pin': 'pin',
	'mxShell:unpin': 'unpin',
	'mxSolutionBuilderAgent:sort-desc': 'sort_desc',
	'mxSolutionBuilderAgent:sort-asc': 'sort_asc',
	'mxSolutionBuilderAgent:support-in-progress': 'support',
	'mxSolutionBuilderAgent:tools': 'tools',
	'mxSolutionBuilderAgent:business-man': 'support_agent',
	'mxDesigner:close': 'close',
	'mxDesigner:close-box': 'disabled_by_default',
	'mxDesigner:view-column': 'view_column',
	'mxDesigner:image-album': 'collections',
	'mxDesigner:file-image-box': 'image',
	'mxDesigner:color-helper': 'minimize',
	'mxDesigner:crop-landscape': 'crop landscape',
	'mxDesigner:format-align-justify': 'format_align_justify',
	'mxDesigner:format-size': 'format_size',
	'mxDesigner:timetable': 'timetable',
	'mxDesigner:checkerboard': 'checkerboard',
	'mxDesigner:pen': 'edit',
	'mxDesigner:plus-circle-outline': 'add_circle_outline',
	'mxDesigner:arrange-send-backward': 'copy_square',
	'mxDesigner:file-document-box': 'file_document',
	'mxDesigner:arrow-right-bold': 'arrow_forward',
	'mxDesigner:play': 'play_arrow',
	'mxDesigner:sort': 'sort-asc',
	'mxDesigner:settings': 'settings',
	'mxDesigner:numeric': 'numeric',
	'mxDesigner:chevron-double-down': 'chevron_double_down',
	'mxDesigner:database': 'database',
	'mxDesigner:alphabetical': 'text',
	'mxDesigner:newspaper': 'newspaper',
	'mxDesigner:crop-free': 'crop_free',
	'm42Dashboards:apps': 'apps',
	'm42Dashboards:favorite': 'favorite',
	'm42Dashboards:menu': 'menu',
	'm42Dashboards:more-vert': 'more_vert',
	'm42Dashboards:stars': 'stars',
	'm42Dashboards:add': 'add',
	'm42Dashboards:arrow-forward': 'arrow_forward',
	'm42Dashboards:check-circle': 'check_circle',
	'm42Dashboards:check-box': 'check_box',
	'm42Dashboards:event': 'event',
	'm42Dashboards:cloud': 'cloud',
	'm42Dashboards:cloud-download': 'cloud_download',
	'm42Dashboards:computer': 'computer',
	'm42Dashboards:group': 'group',
	'm42Dashboards:search': 'search_drop_down',
	'm42Dashboards:refresh': 'refresh',
	'm42Dashboards:person': 'person',
	'm42Dashboards:settings': 'settings',
	'm42Dashboards:exit-to-app': 'exit_to_app',
	'm42Dashboards:chat': 'chat',
	'm42Dashboards:delete': 'delete',
	'm42Dashboards:arrow-back': 'arrow_back',
	'm42Dashboards:pause': 'pause',
	'm42Dashboards:play-arrow': 'play_arrow',
	'm42Dashboards:edit': 'edit',
	'm42Dashboards:view-vert': 'view_stream',
	'm42Dashboards:view-horiz': 'view_horiz',
	'm42Dashboards:save': 'save',
	'm42Dashboards:help': 'help',
	'm42Dashboards:undo': 'undo',
	'm42Dashboards:device-generic': 'device_other',
	'm42Dashboards:device-mac': 'laptop',
	'm42Dashboards:device-windows': 'desktop_windows',
	'm42Dashboards:keyboard-arrow-right': 'keyboard_arrow_right',
	'm42Dashboards:copy-content': 'content_copy',
	'm42Dashboards:error': 'error',
	'm42Dashboards:error-outline': 'error_outline',
	'm42Dashboards:vpn-key': 'vpn_key',
	'm42Dashboards:add-circle-outline': 'add_circle_outline',
	'm42Dashboards:web': 'web',
	'm42Dashboards:filter-list': 'filter_list',
	'm42Dashboards:info': 'info',
	'm42Dashboards:verified-user': 'verified_user',
	'm42Dashboards:done': 'done',
	'm42Dashboards:ipad': 'tablet_mac',
	'm42Dashboards:iphone': 'phone_iphone',
	'm42Dashboards:feedback': 'feedback',
	'm42Dashboards:device-chrome': 'device_chrome',
	'm42Dashboards:device-safari': 'device_safari',
	'm42Dashboards:ghost': 'ghost',
	'm42Dashboards:pie-chart': 'pie_chart',
	'm42Dashboards:column-chart': 'column_chart',
	'm42Dashboards:stacked-column-chart': 'stacked_column_chart',
	'm42Dashboards:chart-areaspline': 'chart_areaspline',
	'm42Dashboards:filter': 'filter_list',
	'm42Dashboards:enterprise-favorite': 'enterprise_favorite',
	'm42Dashboards:vault': 'vault',
	'm42Dashboards:add-to-list': 'add_to_list',
	'm42Dashboards:clear': 'clear',
	'm42Dashboards:expand': 'expand',
	'm42Dashboards:collaps': 'collaps',
};

/**
 * @ngdoc component
 * @name mx.components:mxIcon
 * @module mx.components
 * @restrict 'E'
 * @scope {}
 * @description Custom icon component. Can draw Material-icons or Custom icons like "mxComponents:file-pdf-box"
 * @param {string} icon@ - Name of icon
 * @param {string} iconSrc@ - Source of SVG icon: URL or registered icon name (alternative to `icon`, ignored if `icon` is set)
 * @param {string} color@ - Icon color
 * @param {string} tooltip@ - label text
 * @usage <mx-icon icon="save"></mx-icon>
 * @usage <mx-icon icon="mxComponents:file-pdf-box"></mx-icon>
 * @usage <mx-icon icon-src="/path/to/icon.svg"></mx-icon>
 * @usage <mx-icon icon-src="https://server.name/path/to/icon.svg"></mx-icon>
 * @usage <mx-icon icon-src="iconset:my-cool-icon"></mx-icon>
 */
angular.module('mx.components').component('mxIcon', {
	bindings: {
		icon: '@',
		iconSrc: '@',
		tooltip: '@',
		// TODO: Why should we apply styles for each icons using javascript if we can just use simple CSS just where we really need it like with all other html-elements?
		// Something like this: <mx-icon style="color: {{vm.color}}; font-size: 20px;" ... /> and so on.
		// This approach adds several watchers to each icon multiplaing it.
		// So get rid of `color`, `size` and rework with usual styles.
		color: '@',
		size: '@',
	},
	controller: MxIconCtrl,
	controllerAs: 'vm',
});

MxIconCtrl.$inject = ['$element', '$timeout', '$scope', '$compile'];

function MxIconCtrl($element, $timeout, $scope, $compile) {
	var vm = this;

	vm.$onChanges = function (changes) {
		let iconName = '';
		let useSrc = false;

		if (changes.icon) {
			iconName = iconNamesMapping(changes.icon.currentValue);
		}

		if (!iconName && changes.iconSrc?.currentValue) {
			useSrc = true;
			iconName = changes.iconSrc.currentValue;
		} else if (iconName.includes(':')) {
			// Backward compatibility (legacy behavior):
			// Icon names containing semicolon ':' are considered registered SVG icons.
			// Also, full URLs (with schema and server name 'http(s)://server.name/...) are also
			// treated as SVG icons due to ':' after the schema.
			useSrc = true;
		}

		if (
			(changes.icon || changes.iconSrc || changes.tooltip || changes.color || changes.size) &&
			(vm.icon || changes.icon?.previousValue || vm.iconSrc || changes.iconSrc?.previousValue)
		) {
			$element.html(
				$compile(angular.element(useSrc ? `<md-icon md-svg-src="${iconName}" ${getIconAttrs(false)}></md-icon>` : `<md-icon ${getIconAttrs(true)}>${iconName}</md-icon>`))(
					$scope
				)
			);
		}
	};

	function getIconAttrs(isMDicon) {
		var res = vm.tooltip ? 'title="' + vm.tooltip + '" aria-label="' + vm.tooltip + '" ' : ' role="none" aria-hidden="true" ';
		if (vm.color || vm.size) {
			res += ' style="';
			if (vm.color) {
				res += (isMDicon ? 'color' : 'fill') + ':' + vm.color + ';';
			}
			if (vm.size) {
				res += 'width:' + vm.size + ';height:' + vm.size + ';' + (isMDicon ? 'font-size:' + vm.size + ';' : '');
			}
			res += ';" ';
		}
		return res;
	}

	function iconNamesMapping(icon) {
		const newIconName = iconNameMapping[icon];
		if (newIconName) {
			//TODO: should be changed on console.error
			console.error(`Deprecated icon key usage: "${icon}" detected. Replace with "${newIconName}" till 10.1.1 (Q3) release.`);
		}
		return iconNameMapping[icon] || icon;
	}
}
